<header class="header">
  <div class="logo-red" routerLink="/login"></div>
</header>

<form class="lang-form" [formGroup]="form">
  <div class="lang-box">
    <p-selectButton name="language" 
      formControlName="language" 
      [options]="languageOptions" 
      optionLabel="name"
      optionDisabled="disabled" 
      (onChange)="fixLanguage($event)">
      <ng-template let-item pTemplate>
        <div [class]="item.class"></div>
      </ng-template>
    </p-selectButton>
  </div>
</form>

<div class="login-wrapper">
  <div class="login-card">
    <div class="title">
      <h2>{{ 'user.createAccount.personalData' | transloco }}</h2>
    </div>

    <form *ngIf="form" class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
            <p-dropdown id="country"
                [options]="countryOptions" 
                formControlName="country" 
                name="country"
                (onChange)="setIsBrasil($event)"
                optionLabel="name" 
                [filter]="true"
                filterBy="name"
                [showClear]="true"
                placeholder="{{ 'user.createAccount.country' | transloco }}"
                emptyMessage="{{ 'noResult' | transloco }}"/>
            <div class="field" *ngIf="isBrasil">
                <label for="docNumber" class="field-label">{{ 'user.createAccount.docNumber' | transloco }}*</label>
                <input id="docNumber"
                        formControlName="docNumber"
                        name="docNumber"
                        appDigitOnly
                        [placeholder]="'common.placeholders.cpfCnpj' | transloco"
                        (blur)="getMaskDocNumber()"
                        maxlength="18"
                        [style]="{'width':'100%'}"
                        pInputText />
                <small *ngIf="messagesDocNumber.length" class="field-error">
                  <i class="pi pi-exclamation-circle"></i> {{ messagesDocNumber[0].summary }}
                </small>
            </div>
            <div class="field">
                <label for="name" class="field-label">{{ 'user.createAccount.fullName' | transloco }}*</label>
                <input id="name"
                    class="name"
                    formControlName="name"
                    name="name"
                    type="text"
                    placeholder="{{'user.createAccount.fullName' | transloco }}"
                    maxlength="100"
                    pInputText />
                <small *ngIf="messagesName.length" class="field-error">
                  <i class="pi pi-exclamation-circle"></i> {{ messagesName[0].summary }}
                </small>
            </div>
            <div class="double-input">
                <p-calendar *ngIf="showBirthDate && languageCode === 'pt-br'"
                    id="birthDate"
                    name="birthDate"
                    placeholder="{{ 'user.createAccount.birthDate' | transloco }}*"
                    formControlName="birthDate"
                    appDateOnly
                    [maxDate]="maxDate"
                    dateFormat="dd/mm/yy"
                    [showIcon]="true"
                    [showOnFocus]="false" />
                <p-calendar *ngIf="showBirthDate && languageCode !== 'pt-br'"
                    id="birthDate"
                    name="birthDate"
                    placeholder="{{ 'user.createAccount.birthDate' | transloco }}*"
                    formControlName="birthDate"
                    appDateOnly
                    [maxDate]="maxDate"
                    dateFormat="mm/dd/yy"
                    [showIcon]="true"
                    [showOnFocus]="false" />
            </div>
            <div class="phone-container">
              <div class="country-selector">
                <p-dropdown 
                  [options]="countries" 
                  formControlName="phoneCountry"
                  optionLabel="name" 
                  placeholder="{{ 'user.createAccount.country' | transloco }}*" 
                  (onChange)="updateMask()"
                  [filter]="true"
                  [filterBy]="'name,dialCode'"
                  >
                  <ng-template let-country pTemplate="item">
                    <div class="country-option">
                      <img [src]="country.flag" alt="{{ country.name }}" class="flag" />
                      {{ country.name }} ({{ country.dialCode }})
                    </div>
                  </ng-template>
              
                  <ng-template let-country pTemplate="selectedItem">
                    <div class="selected-country">
                      <img [src]="country.flag" alt="{{ country.name }}" class="flag" />
                      {{ country.dialCode }}
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <p-inputMask
                id="phone"
                formControlName="phone"
                name="phone"
                [mask]="currentMask"
                [unmask]="true"
                slotChar="_"
                [autoClear]="false"
                [style]="{'width':'100%'}"
                placeholder="{{ 'user.createAccount.phone' | transloco }}*"
                  />
            </div>
            <div class="field">
                <label for="email" class="field-label">{{ 'user.createAccount.email' | transloco }}*</label>
                <input id="email"
                    class="email"
                    type="email"
                    formControlName="email"
                    name="email"
                    (blur)="checkEmail()"
                    placeholder="{{ 'user.createAccount.email' | transloco }}"
                    pInputText />
                <small *ngIf="messagesEmail.length" class="field-error">
                  <i class="pi pi-exclamation-circle"></i> {{ messagesEmail[0].summary }}
                </small>
            </div>
            <div class="field">
                <label for="password" class="field-label">{{ 'user.createAccount.password' | transloco }}*</label>
                <p-password id="password"
                    class="ig-pass"
                    formControlName="password"
                    name="password"
                    (input)="equalsPassword()"
                    placeholder="{{ 'user.createAccount.password' | transloco }}"
                    promptLabel="{{ 'user.createAccount.passwordInput' | transloco }}"
                    weakLabel="{{ 'user.createAccount.passwordShort' | transloco }}"
                    mediumLabel="{{ 'user.createAccount.passwordMedium' | transloco }}"
                    strongLabel="{{ 'user.createAccount.passwordLong' | transloco }}"
                    [feedback]="false"
                    [toggleMask]="true"
                    [style]="{'width':'100%'}"
                    [inputStyle]="{'width':'100%'}"/>
                <app-password-strength-checklist
                  [password]="form.get('password')?.value">
                </app-password-strength-checklist>
                <small id="password-help" class="password-help">
                  {{ 'user.createAccount.passwordText' | transloco }}
                </small>
            </div>
            <div class="field">
                <label for="passwordConfirm" class="field-label">{{ 'user.createAccount.passwordConfirm' | transloco }}*</label>
                <p-password id="passwordConfirm"
                    class="ig-pass"
                    [ngClass]="{ 'match': passwordsMatch }"
                    formControlName="passwordConfirm"
                    name="passwordConfirm"
                    placeholder="{{ 'user.createAccount.passwordConfirm' | transloco }}"
                    promptLabel="{{ 'user.createAccount.passwordInput' | transloco }}"
                    weakLabel="{{ 'user.createAccount.passwordShort' | transloco }}"
                    mediumLabel="{{ 'user.createAccount.passwordMedium' | transloco }}"
                    strongLabel="{{ 'user.createAccount.passwordLong' | transloco }}"
                    [feedback]="false"
                    [toggleMask]="true"
                    (input)="equalsPassword()"
                    [style]="{'width':'100%'}"
                    [inputStyle]="{'width':'100%'}"/>
                <small *ngIf="messagesPassword.length" class="field-error">
                  <i class="pi pi-exclamation-circle"></i> {{ messagesPassword[0].summary }}
                </small>
            </div>
            <p-toast key="toastCreateAccount" />

            <div class="inline">
                <p-checkbox id="checkCookies"
                    formControlName="checkCookies"
                    [binary]="true"
                    (onChange)="changeCookies()"
                    inputId="checkCookies" />
                    <label for="checkCookies">
                        {{ 'user.createAccount.checkCookies.v1' | transloco }} 
                        <a [href]="termsofusepdf" target="_blank">
                          {{ 'user.createAccount.checkCookies.v2' | transloco }}
                        </a>
                        {{ 'user.createAccount.checkCookies.v3' | transloco }} 
                        <a [href]="privacypolicypdf" target="_blank">
                          {{ 'user.createAccount.checkCookies.v4' | transloco }}
                        </a>
                    </label>
            </div>
            <p-checkbox id="checkNewsletter"
                formControlName="checkNewsletter"
                [binary]="true"
                label="{{ 'user.createAccount.checkNewsletter' | transloco }}"
                inputId="checkNewsletter" />

                  <p-button
                    type="submit"
                    severity="danger"
                    [raised]="true"
                    [loading]="submitBtnLoading"
                    label="{{'user.createAccount.btnCreateAccount' | transloco}}">
                </p-button>
                <div class="button-wrapper" (click)="backLogin()">
                  <div class="button-inner" >
                    <p-button id="btnBack" name="btnBack" label="{{'user.createAccount.btnBack' | transloco}}"  [raised]="true"
                      styleClass="custom-button"></p-button>
                  </div>
                </div>
                <!-- <button
                  pButton
                  type="button"
                  label="{{'user.createAccount.btnBack' | transloco}}"
                  class="btn-outline"
                  (click)="backLogin()"
                ></button> -->

    </form>
  </div>
  <p-toast key="toastMessages" />
</div>

<footer class="footer" [ngStyle]="{'background-image': footerBackground}">
  <div class="footer-content">
    <!-- <div class="footer-top">
      <select class="language-select">
        <option value="pt-BR">🇧🇷 Brasil - Português</option>
      </select>
    </div> -->
    <div class="footer-logo">
      <img src="assets/img/logo-FTCloud-white.svg" alt="FT Pilot" />
    </div>
    <div class="footer-bottom">
      <p>{{'footer.rightsReserved' | transloco }}</p>
    </div>
  </div>
</footer>

  